import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export default function luckyWinnerCampaignModel() {
  const createCampaign = reactive({
    api: apiEndpoint.bcrm_platform + "/LuckyWinner/CreateCampaign",
    method: "POST",
    xRequest: "",
    payload: {
      name: "",
      Startdate: ""
    },
  });

  const fetchCampaignList = reactive({
    api: apiEndpoint.bcrm_platform + "/LuckyWinner/CampaignList",
    method: "GET",
    xRequest: "",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [],
    },
  });

  const fetchCampaignDetail = reactive({
    api: apiEndpoint.bcrm_platform + "/LuckyWinner/CampaignDetail",
    method: "GET",
    xRequest: "",
    payload: {
      CampaignId: null
    },
  });

  const editCampaign = reactive({
    api: apiEndpoint.bcrm_platform + "/LuckyWinner/EditCampaign",
    method: "POST",
    xRequest: "",
    payload: {
        Id: "",
        name:"",
        Startdate: "",
        Enddate: "",
        Status: false
    },
  });

  const setCampaignStatus = reactive({
    api: apiEndpoint.bcrm_platform + "/LuckyWinner/SetCampaignStatus",
    method: "POST",
    xRequest: "",
    payload: {
        Id:"",
        Status: true
    },
  });

  return {
    createCampaign,
    fetchCampaignList,
    fetchCampaignDetail,
    editCampaign,
    setCampaignStatus
  };
}